import { ArgTypes } from '../utils/ArgValidation';
import { $TSFixMe } from '../utils/typescript';
import { getModelHelpers, InferConstructorArgTypes, InferReadTypes } from './Model';

/**
 * Object used to create a comment on a record
 */
export class RecordComment extends getModelHelpers({
  entityId: { type: ArgTypes.string },
  username: { type: ArgTypes.string },
  message: { type: ArgTypes.string },
  createdAt: { type: ArgTypes.timestamp },
  modifiedAt: { type: ArgTypes.timestamp },
}, 'RecordComment')(({ RecordClass, typesAndDefaults, checkConstructorArgs, checkSetArgs }) => {
  type ConstructorArgTypes = InferConstructorArgTypes<typeof typesAndDefaults>;
  type ReadTypes = InferReadTypes<typeof typesAndDefaults>;
  return class RecordCommentRecord extends RecordClass {
    constructor(args: ConstructorArgTypes) {
      checkConstructorArgs(args);
      super(args);
    }
    set<T extends keyof ReadTypes>(name: T, value: ReadTypes[T]) {
      checkSetArgs(name, value);
      return super.set(name, value);
    }
  };
}) {
  static get argType() { return ArgTypes.instanceOf(this); }

  static fromJSON(json: $TSFixMe) {
    const { entityId, username, createdAt, modifiedAt, message } = json;
    return new RecordComment({
      entityId,
      username,
      createdAt,
      modifiedAt,
      message,
    });
  }

  static fromExistingComment(comment: $TSFixMe, newMessage: string) {
    const { entityId, username, createdAt } = comment;
    const timestamp = Math.floor(Date.now() / 1000);
    return new RecordComment({
      entityId,
      username,
      createdAt,
      modifiedAt: timestamp,
      message: newMessage,
    });
  }
}

export default RecordComment;
